<template>
    <div class="content">
        <div style="margin-left: 20px; font-size: 1.2em;font-weight: 600;" >新闻资讯</div>
        <div class="table">
            <div class="item" >
                <h4 class="name">最新资讯</h4>
                <div class="news">
                    <div class="newsItem" v-for="(item, index) in news" :key="index">
                        <div class="title">{{ item.title }}</div>
                        <div class="date">{{ item.date }}</div>
                    </div>
                </div>
            </div>
            <div class="item">
                <h4 class="name">行业动态</h4>
                <div class="news">
                    <div class="newsItem" v-for="(item, index) in active" :key="index">
                        <div class="title">{{ item.title }}</div>
                        <div class="date">{{ item.date }}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'CommonNews',
    data() {
        return {
            news: [
                { 'title': '2024年办公设备行业发展趋势分析', 'date': '2024-03-15' },
                { 'title': '2024年办公设备行业发展趋势分析', 'date': '2024-03-15' },
            ],
            active: [
                { 'title': '2024年办公设备行业发展趋势分析', 'date': '2024-03-15' },
                { 'title': '2024年办公设备行业发展趋势分析', 'date': '2024-03-15' },
            ]
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
    .content{
        background-color: #fff;
        padding: 20px 5px;
        border-radius: 10px;
        .table{
            display: flex;
            justify-content: space-between;
            padding-left: 20px;
            .item{
                width: 50%;
                margin-right: 20px;
                .name{
                    margin-bottom: 10px;
                }
                .news{
                    .newsItem{
                        border-bottom: 1px solid #eee;
                        padding: 10px 0;
                        .title{
                            font-size: 0.9em;
                            color: #333;
                            margin-bottom: 10px;
                       }
                       .date{
                            font-size: 0.8em;
                            color: #999;
                       }
                    }
                }
            }
        }
    }
</style>